import { render, staticRenderFns } from "./OwnerIndex.vue?vue&type=template&id=3f339269&scoped=true"
import script from "./OwnerIndex.vue?vue&type=script&lang=js"
export * from "./OwnerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f339269",
  null
  
)

export default component.exports